import { render, staticRenderFns } from "./JobVacanciesTab.vue?vue&type=template&id=59e2dcb5&scoped=true"
import script from "./JobVacanciesTab.vue?vue&type=script&lang=js"
export * from "./JobVacanciesTab.vue?vue&type=script&lang=js"
import style0 from "./JobVacanciesTab.vue?vue&type=style&index=0&id=59e2dcb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e2dcb5",
  null
  
)

export default component.exports